var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{ref:"info-icon",staticClass:"mdi mdi-information-outline text-primary font-size-14"}),_c('b-tooltip',{attrs:{"target":function () { return _vm.$refs['info-icon']; },"triggers":"hover"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }